/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Comparison_FocusInputs */

const en_directory_comparison_focus = /** @type {(inputs: Directory_Comparison_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focus`)
};

const zh_directory_comparison_focus = /** @type {(inputs: Directory_Comparison_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比较维度`)
};

/**
* | output |
* | --- |
* | "Focus" |
*
* @param {Directory_Comparison_FocusInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_comparison_focus = /** @type {((inputs?: Directory_Comparison_FocusInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Comparison_FocusInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_comparison_focus(inputs)
	return zh_directory_comparison_focus(inputs)
});
export { directory_comparison_focus as "directory.comparison.focus" }